import $ from "jquery";
import { toast } from "./util/ToastManager";
import axios from "axios";
import moment from 'moment';
import _ from 'lodash';

// Configure axios defaults for login requests
const AXIOS_TIMEOUT = 30000; // 30 seconds

// Helper function to clear previous toasts before showing new ones
const clearAndNotify = (message, type = 'danger', options = {}) => {
    toast.clear();
    return toast.show(message, type, options);
};


const finishSignUp = ({ username, fullname, email, password, sex, birthday, city, education, occupation, telephone, mobile, terms }) => {
    $("#sp-signing-overlay").css("display", "flex");

    axios({
        method: "post",
        url: "/api/register",
        timeout: AXIOS_TIMEOUT,
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
        },
        data: {
            fullname,
            username,
            email,
            password,
            sex,
            birthday,
            city,
            education,
            occupation,
            telephone,
            mobile,
            terms,
        }
    }).then(xhr => {
        let response = xhr.data;
        let status = response.status;

        if (status == 'failure') {
            $("#sp-signing-overlay").css("display", "none");

            let alertMessage = Object.values(response.message);

            function flattenArray(arr) {
                return arr.reduce((result, item) => {
                    return result.concat(Array.isArray(item) ? flattenArray(item) : item);
                }, []);
            }

            const flatMessages = flattenArray(alertMessage);
            // Show each error as a separate toast
            toast.clear();
            flatMessages.forEach(msg => {
                toast.error(msg, { group: 'registration-error' });
            });
        } else {
            $("#sp-signing-overlay").css("display", "none");
            toast.success(response.message, { group: 'registration-success' });
            $('#sign-up-phase').hide();
            $('#completed-phase').show();
            $("#sign-up-back-btn").css('visibility', 'hidden');
        }
    })
    .catch(error => {
        $("#sp-signing-overlay").css("display", "none");

        let errorMessage = 'Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.';

        if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
            errorMessage = 'Η σύνδεση έληξε. Παρακαλώ ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.';
        } else if (!navigator.onLine) {
            errorMessage = 'Δεν υπάρχει σύνδεση στο διαδίκτυο. Παρακαλώ ελέγξτε τη σύνδεσή σας.';
        } else if (error.response?.status >= 500) {
            errorMessage = 'Υπήρξε πρόβλημα με τον διακομιστή. Παρακαλώ δοκιμάστε ξανά αργότερα.';
        }

        clearAndNotify(errorMessage, 'danger', { group: 'network-error' });
    });
}

const mobileAndTabletcheck = () => {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
};

const login = (email, password, rememberMe) => {
    $("#sp-signing-overlay").css("display", "flex");

    axios({
        method: "post",
        url: "/api/login",
        timeout: AXIOS_TIMEOUT,
        headers: {
            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
        },
        data: {
            email,
            password,
            rememberMe
        }
    })
    .then(xhr => {
        let response = xhr.data;
        let status = response.status;

        if (status == "failure") {
            $("#sp-signing-overlay").css("display", "none");
            let keys = Object.keys(response.message);
            toast.clear();
            keys.forEach(key => {
                let errorMessage = response.message[key][0];
                toast.error(errorMessage, { group: 'server-error' });
            });
        } else {
            sessionStorage.setItem('_bt', response.payload.token);
            window.location.href = "/login";
            $("#sp-signing-overlay").css("display", "none");
        }
    })
    .catch(error => {
        $("#sp-signing-overlay").css("display", "none");

        let errorMessage = 'Κάτι πήγε στραβά. Παρακαλώ δοκιμάστε ξανά.';

        if (error.code === 'ECONNABORTED' || error.message?.includes('timeout')) {
            errorMessage = 'Η σύνδεση έληξε. Παρακαλώ ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.';
        } else if (!navigator.onLine) {
            errorMessage = 'Δεν υπάρχει σύνδεση στο διαδίκτυο. Παρακαλώ ελέγξτε τη σύνδεσή σας.';
        } else if (error.response?.status >= 500) {
            errorMessage = 'Υπήρξε πρόβλημα με τον διακομιστή. Παρακαλώ δοκιμάστε ξανά αργότερα.';
        } else if (error.response?.status === 401 || error.response?.status === 403) {
            errorMessage = 'Λάθος email ή κωδικός πρόσβασης.';
        }

        clearAndNotify(errorMessage, 'danger', { group: 'network-error' });
    });
};

const testPasswordAgainstRegex = str => {
    // at least one number, one lowercase and one uppercase letter
    // at least six characters
    var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/;
    return re.test(str);
};

$(document).ready(() => {
    console.log("Loaded login page. Document ready!");
    let emailElement = $("#sp-email");
    let passwordElement = $("#sp-password");
    let rememberMeElement = $("#sp-remember-me");
    let today = new Date().toISOString().split('T')[0];
    $('#sp-birthdate').attr('max', today);

    // $("body").on("keyup", event => {
    //     if (event.keyCode === 13) {
    //         // Cancel the default action, if needed
    //         event.preventDefault();
    //         // Trigger the button element with a click
    //         return attemptLogin();
    //     }
    // });

    $("body").on("click", "#home-btn", () => {
        console.log("Clicked");
        window.location = '/';
    });

    $("body").on("click", "#sign-in-btn-new", event => {
        return attemptLogin();
    });

    $("body").on("click", "#sign-up-btn", event => {
        return attemptSignUp();
    });

    $("body").on("click", "#sign-up-btn-finish", event => {
        return attemptSignUp();
    });

    $("body").on("click", "#register-btn", event => {
        return window.location = '/register';
    });

    $("body").on("click", "#login-btn", event => {
        return window.location = '/';
    });

    $("body").on("change", emailElement, () => {
        emailElement.removeClass("sp-error-input");
    });

    $("body").on("change", passwordElement, () => {
        passwordElement.removeClass("sp-error-input");
    });

    console.log("mobileAndTabletcheck: "+mobileAndTabletcheck())

    if (mobileAndTabletcheck()) {
        $("#sp-birthdate").attr('type', 'date');
    } else {
        $("body").on("focusout", "#sp-birthdate", (e) => {
            e.target.type = 'text';
    
            if (!e.target.value || !e.target.value.length) {
                return;
            }
            let transformedValue = moment(e.target.value, "YYYY-MM-DD").format("DD/MM/YYYY");
            e.target.value = transformedValue;
        });
    }

    $("body").on("focus", ".uk-input", (e) => {
        $('#' + e.target.id).removeClass('uk-form-danger');
        if (e.target.id == 'sp-mobile-alt') {
            $('#sp-mobile').removeClass('uk-form-danger');
        }

        if (e.target.id == 'sp-mobile') {
            $('#sp-mobile-alt').removeClass('uk-form-danger');
        }
    });

    $("body").on("click", "#sign-up-back-btn", (e) => {
        step = 0;
        $("#stage-2").hide();
        $("#sign-up-btn-finish").hide();

        $("#stage-1").show();
        $("#sign-up-btn").show();

        $("#sign-up-back-btn").css('visibility', 'hidden');
    });

    $('#completed-phase').hide();
    $("#sign-up-btn-finish").hide();
    $("#stage-2").hide();


    $("#sign-up-btn-finish").hide();

    const signUpStages = ['starting', 'finishing'];
    let step = 0;

    const attemptSignUp = () => {
        let currentStage = signUpStages[step];

        // stage 1 elements
        let usernameElement = $('#sp-username');
        let emailElement = $('#sp-email');
        let fullnameElement = $('#sp-fullname');
        let passwordElement = $('#sp-password');
        let passwordConfirmElement = $('#sp-password-confirm');
        let birthdateElement = $('#sp-birthdate');

        // stage 2 elements
        let genderElement = $("input[name='gender-group']:checked");
        let cityElement = $('#sp-city');
        let educationElement = $('#sp-education');
        let occupationElement = $('#sp-occupation');
        let mobileElement = $('#sp-mobile');
        let altMobileElement = $('#sp-mobile-alt');
        let termsElement = $('#sp-terms');

        // console.log("Step: " + step);
        // console.log("currentStage: " + currentStage);

        if (currentStage == 'starting') {

            if (!checkStageOne(usernameElement, emailElement, fullnameElement, passwordElement, passwordConfirmElement, birthdateElement)) {
                return;
            }

            step = 1;

            $("#sign-up-back-btn").css('visibility', 'visible');

            $("#stage-1").hide();
            $("#sign-up-btn").hide();

            $("#stage-2").show();
            $("#sign-up-btn-finish").show();
        } else {

            if (!checkStageTwo(genderElement, cityElement, occupationElement, educationElement, mobileElement, altMobileElement, termsElement)) {
                return;
            }

            finishSignUp({
                fullname: fullnameElement.val().trim(),
                username: usernameElement.val().trim(),
                email: emailElement.val().trim(),
                password: passwordElement.val().trim(),
                sex: genderElement.val().trim(),
                birthday: birthdateElement.val().trim(),
                city: cityElement.val().trim(),
                education: educationElement.val().trim(),
                occupation: occupationElement.val().trim(),
                telephone: altMobileElement.val().trim(),
                mobile: mobileElement.val().trim(),
                terms: termsElement.is(":checked"),
            });

            console.log("Finishing");
        }
    }

    const checkStageOne = (unameEl, emailEl, fnameEl, pEl, pconfEl, birthdayEl) => {
        console.log("Checking step 1");
        let shouldFail = false;
        let username = unameEl.val();
        if (!username || !(username.trim().length)) {
            unameEl.addClass('uk-form-danger');
            $('#' + unameEl.attr('id') + '-error').css('display', 'flex').html('Username is required');
            shouldFail = true;
        } else {
            unameEl.addClass('uk-form-success');
            $('#' + unameEl.attr('id') + '-error').css('display', 'none');
        }

        let email = emailEl.val();
        if (!email || !(email.trim().length)) {
            emailEl.addClass('uk-form-danger');
            $('#' + emailEl.attr('id') + '-error').css('display', 'flex').html('Email is required');
            shouldFail = true;
        } else {
            emailEl.addClass('uk-form-success');
            $('#' + emailEl.attr('id') + '-error').css('display', 'none');
        }

        let fullname = fnameEl.val();
        if (!fullname || !(fullname.trim().length)) {
            fnameEl.addClass('uk-form-danger');
            $('#' + fnameEl.attr('id') + '-error').css('display', 'flex').html('Fullname is required');
            shouldFail = true;

        } else {
            fnameEl.addClass('uk-form-success');
            $('#' + fnameEl.attr('id') + '-error').css('display', 'none');
        }

        let password = pEl.val();
        let passConfirm = pconfEl.val();

        let passwordExists = !(!password || !(password.trim().length));
        let confirmExists = !(!passConfirm || !(passConfirm.trim().length));
        let areEqual = passwordExists && confirmExists && (password.trim() == passConfirm.trim());

        if (passwordExists && (password.trim().length < 6)) {
            pEl.addClass('uk-form-danger');
            pconfEl.addClass('uk-form-danger');
            $('#' + pEl.attr('id') + '-error').css('display', 'flex').html('Password is required and must be at least 6 characters.');

            shouldFail = true;
        } else if (!areEqual) {
            pEl.addClass('uk-form-danger');
            pconfEl.addClass('uk-form-danger');
            $('#' + pconfEl.attr('id') + '-error').css('display', 'flex').html('Password fields must match.');

            shouldFail = true;
        } else {
            pEl.addClass('uk-form-success');
            pconfEl.addClass('uk-form-success');
            $('#' + pconfEl.attr('id') + '-error').css('display', 'none');
            $('#' + pEl.attr('id') + '-error').css('display', 'none');
        }

        let bdate = birthdayEl.val();
        if (!bdate || !(bdate.trim().length)) {
            birthdayEl.addClass('uk-form-danger');
            $('#' + birthdayEl.attr('id') + '-error').css('display', 'flex').html('Birthdate is required.');
            shouldFail = true;
        } else {
            birthdayEl.addClass('uk-form-success');
            $('#' + birthdayEl.attr('id') + '-error').css('display', 'none');
        }

        return !shouldFail;
    }

    const checkStageTwo = (genderElement, cityElement, occupationElement, educationElement, mobileElement, altMobileElement, termsElement) => {
        let shouldFail = false;
        let gender = genderElement.val();
        if (!gender || !(gender.trim().length)) {
            genderElement.addClass('uk-form-danger');
            $('#sp-gender-error').css('display', 'flex').html('Gender is required.');
            shouldFail = true;
        } else {
            genderElement.addClass('uk-form-success');
            $('#sp-gender-error').css('display', 'none');
        }

        let city = cityElement.val();
        if (!city || !(city.trim().length)) {
            cityElement.addClass('uk-form-danger');
            $('#' + cityElement.attr('id') + '-error').css('display', 'flex').html('City is required.');
            shouldFail = true;
        } else {
            cityElement.addClass('uk-form-success');
            $('#' + cityElement.attr('id') + '-error').css('display', 'none');
        }

        let occupation = occupationElement.val();
        if (!occupation || !(occupation.trim().length)) {
            occupationElement.addClass('uk-form-danger');
            $('#' + occupationElement.attr('id') + '-error').css('display', 'flex').html('Occupation is required.');
            shouldFail = true;
        } else {
            occupationElement.addClass('uk-form-success');
            $('#' + occupationElement.attr('id') + '-error').css('display', 'none');
        }

        let education = educationElement.val();
        if (!education || !(education.trim().length)) {
            educationElement.addClass('uk-form-danger');
            $('#' + educationElement.attr('id') + '-error').css('display', 'flex').html('Education is required.');
            shouldFail = true;
        } else {
            educationElement.addClass('uk-form-success');
            $('#' + educationElement.attr('id') + '-error').css('display', 'none');
        }

        let mobile = mobileElement.val();
        let altMobile = altMobileElement.val();
        let mobileIsNotPresent = !mobile || !(mobile.trim().length);
        let fixedIsNotPresent = !altMobile || !(altMobile.trim().length);

        mobileElement.removeClass('uk-form-success');
        altMobileElement.removeClass('uk-form-success');
        if (mobileIsNotPresent && fixedIsNotPresent) {
            mobileElement.addClass('uk-form-danger');
            // $('#'+mobileElement.attr('id')+'-error').css('display', 'flex').html('At least one phone number is required.');
            altMobileElement.addClass('uk-form-danger');
            $('#' + altMobileElement.attr('id') + '-error').css('display', 'flex').html('At least one phone number is required.');
            shouldFail = true;
        } else if (mobileIsNotPresent && !fixedIsNotPresent) {
            $('#' + altMobileElement.attr('id') + '-error').css('display', 'none');
            altMobileElement.addClass('uk-form-success');
        } else if (!mobileIsNotPresent && fixedIsNotPresent) {
            $('#' + altMobileElement.attr('id') + '-error').css('display', 'none');
            mobileElement.addClass('uk-form-success');
        } else {
            $('#' + altMobileElement.attr('id') + '-error').css('display', 'none');
            mobileElement.addClass('uk-form-success');
            altMobileElement.addClass('uk-form-success');
        }

        // if (!mobile || !(mobile.trim().length)) {
        //     mobileElement.addClass('uk-form-danger');
        //     $('#'+mobileElement.attr('id')+'-error').css('display', 'flex').html('Mobile phone is required.');

        //     shouldFail = true;
        // } else {
        // $('#'+mobileElement.attr('id')+'-error').css('display', 'none');

        // mobileElement.addClass('uk-form-success');
        // }

        // let altMobile = altMobileElement.val();
        // if (!altMobile || !(altMobile.trim().length)) {
        // altMobileElement.addClass('uk-form-danger');
        // $('#'+altMobileElement.attr('id')+'-error').css('display', 'flex').html('Fixed phone is required.');

        //     shouldFail = true;
        // } else {
        //     $('#'+altMobileElement.attr('id')+'-error').css('display', 'none');

        //     altMobileElement.addClass('uk-form-success');
        // }

        let acceptedTerms = termsElement.is(":checked");
        if (!acceptedTerms) {
            termsElement.addClass('uk-form-danger');
            shouldFail = true;
            $('#sp-terms-error').css('display', 'flex').html('You must agree with the Terms of Service and Privacy Policy to continue.');
        } else {
            termsElement.addClass('uk-form-success');
            $('#sp-terms-error').css('display', 'none');
        }

        return !shouldFail;
    }

    const attemptLogin = () => {
        event.preventDefault();
        event.stopPropagation();
        toast.clear();

        // Get the email input element as DOM element for validity checking
        const emailInput = document.getElementById('sp-email');
        // Set the type to email to leverage HTML5 validation
        emailInput.type = 'email';

        let email = emailElement.val();
        let password = passwordElement.val();
        let rememberMe = false; //rememberMeElement.prop("checked");

        if (!email || !email.length) {
            emailElement.addClass("sp-error-input");
            return clearAndNotify("Το email είναι υποχρεωτικό.", 'danger', { group: 'email-required' });
        } else if (!emailInput.checkValidity()) {
            emailElement.addClass("sp-error-input");
            return clearAndNotify("Παρακαλώ εισάγετε μια έγκυρη διεύθυνση email.", 'danger', { group: 'email-invalid' });
        } else {
            emailElement.addClass("sp-correct-input");
        }

        if (!password || !password.length) {
            passwordElement.addClass("sp-error-input");
            return clearAndNotify("Ο κωδικός πρόσβασης είναι υποχρεωτικός.", 'danger', { group: 'password-required' });
        } else {
            passwordElement.addClass("sp-correct-input");
        }

        return login(email, password, rememberMe);
    };
});
